module.exports = __webpack_public_path__ + "static/media/swacky-white.4f94b162.jpg";